// extracted by mini-css-extract-plugin
export var alignLeft = "alignLeft___LOIEk";
export var alignRight = "alignRight___w4YZp";
export var alignCenter = "alignCenter___TbfWu";
export var alignStretch = "alignStretch___UjEUj";